import { render } from "./ButtonsTest.vue?vue&type=template&id=756b9c64&scoped=true"
import script from "./ButtonsTest.vue?vue&type=script&lang=js"
export * from "./ButtonsTest.vue?vue&type=script&lang=js"

import "./ButtonsTest.vue?vue&type=style&index=0&id=756b9c64&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756b9c64"]])

export default __exports__